import React, { useEffect, useRef, useState } from "react";
import * as handpose from "@tensorflow-models/handpose";
import Webcam from "react-webcam";
import "regenerator-runtime/runtime";
import "@tensorflow/tfjs-backend-webgl";

export const CameraView = (props) => {
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);
  const [isInitialized, setInitialized] = useState(false)
  const style = {
    position: "absolute",
    marginLeft: "auto",
    marginRight: "auto",
    left: 0,
    right: 0,
    textAlign: "center",
    width: 640,
    height: 480
  };

  const drawPoint = (canvasCtx, y, x, r) => {
    canvasCtx.beginPath();
    canvasCtx.arc(x, y, r, 0, 2 * Math.PI);
    canvasCtx.fill();
  };

  const drawPath = (canvasCtx, points, closePath) => {
    const region = new Path2D();
    
    region.moveTo(points[0][0], points[0][1]);
    for (let i = 1; i < points.length; i++) {
      const point = points[i];
      region.lineTo(point[0], point[1]);
    }

    if (closePath) {
      region.closePath();
    }
    canvasCtx.stroke(region);
  };

  const drawKeypoints = (canvasCtx, predictions) => {

    const keypoints = predictions[0].landmarks

    const fingerLookupIndices = {
        thumb: [0, 1, 2, 3, 4],
        indexFinger: [0, 5, 6, 7, 8],
        middleFinger: [0, 9, 10, 11, 12],
        ringFinger: [0, 13, 14, 15, 16],
        pinky: [0, 17, 18, 19, 20]
    };
    for (let i = 0; i < keypoints.length; i++) {
      const x = keypoints[i][0];
      const y = keypoints[i][1];
      drawPoint(canvasCtx, y - 2, x - 2, 3);
    }
    
    const fingers = Object.keys(fingerLookupIndices);
    for (let i = 0; i < fingers.length; i++) {
      const finger = fingers[i];
      const fingerIndex = fingerLookupIndices[finger]
      const points = fingerIndex.map((idx) => keypoints[idx]);

      drawPath(canvasCtx, points, false);
    }
  };

  const prerender = () => {
    webcamRef.current.video.width =  webcamRef.current.video.videoWidth;
    webcamRef.current.video.height = webcamRef.current.video.videoHeight;
    canvasRef.current.width = webcamRef.current.video.videoWidth;
    canvasRef.current.height = webcamRef.current.video.videoHeight;
  }

    
  const renderView = async (net) => {
    if (
      typeof webcamRef.current !== "undefined" &&
      webcamRef.current !== null &&
      webcamRef.current.video !=null &&
      webcamRef.current.video.readyState === 4
    ) {
      prerender();
      const canvasCtx = canvasRef.current.getContext("2d")  
      firstPreRender(canvasCtx)
      const predictions = await net.estimateHands(webcamRef.current.video);
      if (predictions.length > 0) {
        drawKeypoints(canvasCtx, predictions);
        props.synchronizePredictions(predictions);
      }
      canvasCtx.translate(-canvasRef.current.width, 0);
    }
  };

  const firstPreRender = (canvasCtx) => {
    if(isInitialized) {
        canvasCtx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        canvasCtx.strokeStyle = 'red';
        canvasCtx.fillStyle = 'red';
        canvasCtx.translate(canvasRef.current.width, 0);
        canvasCtx.scale(-1, 1);
        console.log("Pipe initialization complete")
        console.log(canvasCtx)
        setInitialized(1==1)
        console.log(isInitialized)
    }
  }

  const pipeRenderer = async () => {
    const handPoseNetwork = await handpose.load();
    console.log("Hand Pose Network loaded");
    setInterval(() => {
    renderView(handPoseNetwork);
    }, 100);
  };

  useEffect(() => {
      pipeRenderer()
  }, [])

  return (
    <>
      <Webcam ref={webcamRef} style={style} />
      <canvas ref={canvasRef} style={style} />
    </>
  );
};
